import React from 'react';
import clsx from "clsx";
import {TabsProps} from "./Tabs.types";

export const Tabs = <T, >(props: TabsProps<T>) => {

    const onChange = (tabId: T) => () => {
        props.onChange(tabId);
    }

    return (
        <div className="flex flex-shrink-0 justify-between bg-[#272D33] rounded-t-[8px]">
            {props.tabs.map((tab, i) => (
                <div
                    key={i}
                    onClick={onChange(tab.value)}
                    className={clsx(
                        "cursor-pointer flex justify-center items-center text-[14px] w-full h-[40px] uppercase",
                        props.value === tab.value ? "text-white bg-[#121518] border-b-[3px] border-[#0D83BA]" : "text-[#ABABAB]",
                        props.value === tab.value && (i === 0 ? "rounded-tr-[8px]" : "rounded-tl-[8px]"))}
                >
                    {tab.label}
                </div>
            ))}
        </div>
    )
}
